var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"r-btn",class:_vm.cls,on:{"click":_vm.handleClick}},[_c('Icon',{staticClass:"b-icon",attrs:{"name":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }